export default __webpack_public_path__ + "static/media/delievers19.1ed0f24f.jpeg";